import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import Error from '@material-ui/icons/Error';

const SIZES = [
  'default',
  'large',
  'medium',
  'small',
];

const useStyles = buildUseStyles('ErrorIcon', () => ({
  root: {},
}));

const ErrorIcon = ({
  className,
  size,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Icon
      className={classNames(className, classes.root)}
      fill={'red'}
      icon={Error}
      fontSize={size}
    />
  );
};

ErrorIcon.defaultProps = {
  className: '',
  size: 'default',
};

ErrorIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(SIZES),
};

export default ErrorIcon;
